// KAN-895: which build and which site a Sentry report came from. The site is
// decided by the BUILD setting (REACT_APP_SUPABASE_ENV), never the web address.
// Prod keeps the name 'production' so existing Sentry alerts and filters still match.
import { APP_VERSION, BUILD_CODE } from '../../config/appVersion';

export function sentryEnvironment(supabaseEnv = process.env.REACT_APP_SUPABASE_ENV) {
  return supabaseEnv === 'development' ? 'dev' : 'production';
}

export function sentryRelease(version = APP_VERSION, build = BUILD_CODE) {
  return `crewvex@${version}+${build}`;
}
